module.exports = __webpack_public_path__ + "media/images/QMARK-logo-33624a1e2fd380c05a8939563605af66.png";